/** 0: 方=列表, 1: 電影列表 */
export enum CategoryMode {
  /** 0 方案列表 */
  Default,
  /** 1 電影列表 */
  Movie,
}
/** 0:=顯示, 1: 不顯示 */
export enum CategoryOnboard {
  /** 0: 顯示 */
  Show,
  /** 1: 不顯示 */
  Hidden,
}
/** 選日期時可選日期範圍 */
export enum CalendarDayMode {
  /** 0: 7 天 */
  SevenDays,
  /** 1: 30 天 */
  ThirtyDays,
  /** 2: 180 天 */
  OneHundredEightyDays,
}
/** 分類類型 */
export enum CategoryType {
  /** 0: 分類 */
  Category,
  /** 1: 主題 */
  Theme,
}
